<template>
  <div class="mt-4">
    <div @click="navigateToFlightOperationsView()" style="cursor: pointer;">
      <b-icon icon="chevron-left"></b-icon>&nbsp;Zurück
    </div>

    <b-alert variant="info" show class="text-center mt-4">
      <div>
        <b-icon icon="info-circle" font-scale="1.5"></b-icon>
        <br />
        Um einen Dienstbucheintrag zu erstellen, muss das <strong>heutige Datum</strong> ausgewählt werden. <br>
        Archivierte Einträge können als PDF-Dokument heruntergeladen werden.
      </div>
    </b-alert>

    <v-calendar :attributes="attributes" @dayclick="checkServiceBookEntry" is-expanded class="mt-4"/>
    

    <b-card class="shadow-sm rounded-lg border-0 legend-card mt-4 mb-2">
      <div class="mb-3 d-flex align-items-center">
        <b-icon icon="list" variant="danger" font-scale="1.2" class="mr-2" />
        <h5 class="mb-0 text-dark">Legende</h5>
      </div>
      <ul class="list-unstyled mb-0">
        <li
          v-for="(item, index) in legendItems"
          :key="index"
          class="d-flex align-items-center mb-3"
        >
          <span
            class="legend-dot mr-3"
            :style="{ backgroundColor: item.color }"
          ></span>
          &nbsp;
          <div class="legend-label text-muted">{{ item.label }}</div>
        </li>
      </ul>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: { },
  data() {
    return {
      currentDate: null,
      formattedDate: null,
      isActive: false,

      loading: false,

      attributes: [],

      legendItems: [
        { label: 'Heutiger Tag', color: '#3182ce' },
        //{ label: 'Flugbetrieb gestartet', color: '#38a169' },
        //{ label: 'Flugbetrieb abgesagt', color: '#e53e3e' },
        { label: 'Archiviert', color: '#788494' },
      ],

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },

  methods: {
    serviceBookCreateEntry() {
      this.$router.push("/flight-operations/service-book/new-entry");
    },

    serviceBookEditEntry() {
      this.$router.push("/flight-operations/service-book/edit-entry");
    },

    openServiceBookArchive() {
      this.$router.push("/flight-operations/service-book/archive");
    },

    navigateToFlightOperationsView() {
      this.$router.push(`/flight-operations`);
    },


    checkServiceBookEntry(date) {
      const nowDate = this.currentDate

      if (date.id === nowDate) {
        this.$router.push("/flight-operations/service-book/new-entry");
      } else {
        this.exportPdf(date);
      }
    },

    async exportPdf(date) {
      this.loading = true;
      try {
        const response = await axios.post(
          this.apiUrl + "/service-book/export-pdf",
          {
            date: date.id,
          },
          {
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", date.id + "_Dienstbucheintrag.pdf");
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.loading = false;
      } catch (error) {
        console.error("Fehler beim Exportieren des PDFs:", error);
        this.loading = false;
      }
    },
  },

  beforeMount() {
    this.loading = true;

    axios
      .get(this.apiUrl + "/service-book/get-options")
      .then((response) => {
        this.currentDate = response.data.date.currentDate;
        this.formattedDate = response.data.date.formattedDate;

        this.isActive = response.data.isActive;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);

        if (error.status === 401) {
          localStorage.removeItem("token");
        }
      });

    axios
      .get(this.apiUrl + "/service-book/get-entries")
      .then((response) => {
        this.entries = response.data.entries;


        this.attributes = [
          {
            highlight: 'blue',
            dates: [new Date(this.currentDate)],
          },
          {
            highlight: 'gray',
            dates: Object.values(this.entries)
              .filter(item => item.date !== this.currentDate)
              .map(item => new Date(item.date)),
          },
        ];
      })
      .catch((error) => {
        console.error("Error fetching data:", error);

        if (error.status === 401) {
          localStorage.removeItem("token");
        }
      });

    

    this.loading = false;
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}

h1 {
  text-align: center;
}

.tile {
  padding-top: 15%;
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 10px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
}

.tile:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

b-icon {
  margin-bottom: 8px;
}

h5 {
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  color: #333;
}

@media (min-width: 767px) {
  .flight-operations-row {
    margin: auto;
    width: 50%;
  }
}

.legend-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #ccc;
}
.legend-label {
  font-size: 0.95rem;
  font-weight: 500;
}
.legend-card {
  background-color: #f8f9fa;
  padding: 1.25rem;
}
</style>
